import { Route, Routes } from "react-router-dom";

import SignInPage from "@/app/signin/page";
import DefaultLayout from "@/layout/hydrogen_layout";
import routes from "./routes";

// Hydrogen
// Dashboard

// Appointment

// ecommerce

// ecommerce - products
// ecommerce - categories

// ecommerce - orders

// ecommerce - orders

// support

// job

// file

// event - calender

// role permission
import RolePermission from "@/app/(hydrogen)/roles-permissions/page";
import RolesManagementPage from "@/app/(hydrogen)/roles-permissions/roles";

// Image viewer

// Image viewer

// logistics
import LogisticsCustomerProfile from "@/app/(hydrogen)/clients/customer-profile/page";
import LogisticsDashboard from "@/app/(hydrogen)/orders/page";
import LogisticsShipmentEdit from "@/app/(hydrogen)/shipments/[id]/edit/page";
import LogisticsShipmentDetails from "@/app/(hydrogen)/shipments/[id]/page";
import LogisticsShipmentCreate from "@/app/(hydrogen)/shipments/create/page";
import LogisticsShipmentList from "@/app/(hydrogen)/shipments/page";
import LogisticsTracking from "@/app/(hydrogen)/orders/tracking/[id]/page";

import HydrogenDashboard from "@/app/(hydrogen)/page";

// Widgets

// Pages
import AccessDenied from "@/app/(other-pages)/access-denied/page";
import ComingSoon from "@/app/(other-pages)/coming-soon/page";
import OtherPagesLayout from "@/app/(other-pages)/layout";
import Maintenance from "@/app/(other-pages)/maintenance/page";
import NotFound from "@/app/(other-pages)/not-found/page";
import Welcome from "@/app/(other-pages)/welcome/page";

// Authentication
// SignUp
import SignUpModern from "@/app/auth/(sign-up)/sign-up-1/page";
import SignUpVintage from "@/app/auth/(sign-up)/sign-up-2/page";
import SignUpTrendy from "@/app/auth/(sign-up)/sign-up-3/page";
import SignUpElegant from "@/app/auth/(sign-up)/sign-up-4/page";
import SignUpClassic from "@/app/auth/(sign-up)/sign-up-5/page";

// SignIp
import SignInModern from "@/app/auth/(sign-in)/sign-in-1/page";
import SignInVintage from "@/app/auth/(sign-in)/sign-in-2/page";
import SignInTrendy from "@/app/auth/(sign-in)/sign-in-3/page";
import SignInElegant from "@/app/auth/(sign-in)/sign-in-4/page";
import SignInClassic from "@/app/auth/(sign-in)/sign-in-5/page";

// ForgetPassword
import ForgetPasswordPage from "@/app/auth/(forgot-password)/forgot-password-1/page";
import ForgotPasswordVintage from "@/app/auth/(forgot-password)/forgot-password-2/page";
import ForgotPasswordTrendy from "@/app/auth/(forgot-password)/forgot-password-3/page";
import ForgotPasswordElegant from "@/app/auth/(forgot-password)/forgot-password-4/page";
import ForgotPasswordClassic from "@/app/auth/(forgot-password)/forgot-password-5/page";

// OTP
import OtpModern from "@/app/auth/(otp)/otp-1/page";
import OtpVintage from "@/app/auth/(otp)/otp-2/page";
import OtpTrendy from "@/app/auth/(otp)/otp-3/page";
import OtpElegant from "@/app/auth/(otp)/otp-4/page";
import OtpClassic from "@/app/auth/(otp)/otp-5/page";
import OrderListPage from "@/app/(hydrogen)/orders/page";
import CreateOrderPage from "@/app/(hydrogen)/orders/create/page";
import EditOrderPage from "@/app/(hydrogen)/orders/edit/page";
import OrderDetails from "@/app/(hydrogen)/orders/[id]/page";
import CategoryListPage from "@/app/(hydrogen)/categories/page";
import CreateRolePage from "@/app/(hydrogen)/roles-permissions/createRole";
import EditRolePage from "@/app/(hydrogen)/roles-permissions/editRole";
import ClientListPage from "@/app/(hydrogen)/clients/page";
import CreateClientPage from "@/app/(hydrogen)/clients/create-client";
import AccessDeniedPage from "@/app/(other-pages)/access-denied/page";
import BillingDetailsPage from "@/app/(hydrogen)/orders/billing/page";
import SystemSettingListPage from "@/app/(hydrogen)/system-settings/page";
import CreateSystemSettingPage from "@/app/(hydrogen)/system-settings/create/page";
import ServiceListPage from "@/app/(hydrogen)/services/page";
import CreateEditService from "@/app/shared/settings/services/create-edit";
import CreateServicePage from "@/app/(hydrogen)/services/create/createPage";
import EditServicePage from "@/app/(hydrogen)/services/create/editPage";
import NotificationListPage from "@/app/(hydrogen)/notifications/page";
import PaymentsListPage from "@/app/(hydrogen)/payments/page";
import CreatePartnerPage from "@/app/(hydrogen)/partiners/create/createPage";
import EditPartnerPage from "@/app/(hydrogen)/partiners/create/editPage";
import PartnerListPage from "@/app/(hydrogen)/partiners/page";
import OrderReportPage from "@/app/(hydrogen)/orders/reports/page";

function Routers() {
    return (
        <Routes>
            <Route path="/" element={<SignInPage />} />
            <Route
                path={routes.signIn}
                element={
                    // <Suspense fallback={<Loading />}>
                    <SignInPage />
                    // </Suspense>
                }
            />

            <Route
                path={routes.auth.forgotPassword1}
                element={<ForgetPasswordPage />}
            />
            <Route
                path={routes.auth.forgotPassword2}
                element={<ForgotPasswordVintage />}
            />
            <Route
                path={routes.auth.forgotPassword3}
                element={<ForgotPasswordTrendy />}
            />
            <Route
                path={routes.auth.forgotPassword4}
                element={<ForgotPasswordElegant />}
            />
            <Route
                path={routes.auth.forgotPassword5}
                element={<ForgotPasswordClassic />}
            />

            {/* other Pages */}
            <Route element={<OtherPagesLayout />}>
                <Route path={routes.welcome} element={<Welcome />} />
                <Route path={routes.comingSoon} element={<ComingSoon />} />
                <Route path={routes.accessDenied} element={<AccessDenied />} />
                <Route path={routes.notFound} element={<NotFound />} />
                <Route path={routes.maintenance} element={<Maintenance />} />
            </Route>

            {/* Auth */}
            {/* <Route></Route> */}

            {/* hydrogen */}
            <Route element={<DefaultLayout />}>
                <Route path={"/"} element={<HydrogenDashboard />} />

                {/* Orders  */}
                <Route
                    path={routes.orders.dashboard}
                    element={<HydrogenDashboard />}
                />
                <Route path={routes.orders.list} element={<OrderListPage />} />
                <Route
                    path={routes.orders.createAgentOrder}
                    element={<CreateOrderPage isAgent={true} />}
                />
                <Route
                    path={routes.orders.createOrder}
                    element={<CreateOrderPage isAgent={false} />}
                />
                <Route
                    path={routes.orders.customerProfile}
                    element={<LogisticsCustomerProfile />}
                />
                <Route
                    path={routes.orders.editAgentOrder(":id")}
                    element={<EditOrderPage isAgent={true} />}
                />
                <Route
                    path={routes.orders.editOrder(":id")}
                    element={<EditOrderPage isAgent={false} />}
                />
                <Route
                    path={routes.orders.orderDetails(":id")}
                    element={<OrderDetails />}
                />
                <Route
                    path={routes.orders.tracking(":id")}
                    element={<LogisticsTracking />}
                />

                <Route
                    path={routes.orders.billingDetails(":id")}
                    element={<BillingDetailsPage />}
                />

                <Route
                    path={routes.orders.report}
                    element={<OrderReportPage />}
                />

                {/* Order End */}

                {/* Category */}
                <Route
                    path={routes.categories.list}
                    element={<CategoryListPage />}
                />
                {/* Category End */}

                {/* Client */}

                <Route
                    path={routes.clients.list}
                    element={<ClientListPage />}
                />

                <Route
                    path={routes.clients.create}
                    element={<CreateClientPage />}
                />

                <Route
                    path={routes.clients.details(":id")}
                    element={<LogisticsCustomerProfile />}
                />

                {/* Client End */}

                {/* Settings */}
                <Route
                    path={routes.settings.general.create}
                    element={<CreateSystemSettingPage />}
                />

                {/* services */}
                <Route
                    path={routes.settings.services.list}
                    element={<ServiceListPage />}
                />

                <Route
                    path={routes.settings.services.create}
                    element={<CreateServicePage />}
                />

                <Route
                    path={routes.settings.services.edit(":id")}
                    element={<EditServicePage />}
                />

                {/* Settings End */}

                {/* Partner */}
                <Route
                    path={routes.settings.partners.list}
                    element={<PartnerListPage />}
                />

                <Route
                    path={routes.settings.partners.create}
                    element={<CreatePartnerPage />}
                />

                <Route
                    path={routes.settings.partners.edit(":id")}
                    element={<EditPartnerPage />}
                />

                {/* Partner End */}

                {/* notification */}
                <Route
                    path={routes.settings.notifications}
                    element={<NotificationListPage />}
                />
                {/* notification End */}

                {/* payments */}
                <Route
                    path={routes.payments.list}
                    element={<PaymentsListPage />}
                />
                {/* payments End */}

                {/* Shipments */}
                <Route
                    path={routes.shipments.list}
                    element={<LogisticsShipmentList />}
                />

                <Route
                    path={routes.shipments.createShipment}
                    element={<LogisticsShipmentCreate />}
                />

                <Route
                    path={routes.shipments.editShipment(":id")}
                    element={<LogisticsShipmentEdit />}
                />

                <Route
                    path={routes.shipments.shipmentDetails(":id")}
                    element={<LogisticsShipmentDetails />}
                />

                {/* Shipments End */}

                {/* Profile */}

                <Route
                    path={routes.orders.dashboard}
                    element={<LogisticsDashboard />}
                />

                {/* Role */}
                <Route
                    path={routes.userManagement.users}
                    element={<RolePermission />}
                />
                <Route
                    path={routes.userManagement.roles}
                    element={<RolesManagementPage />}
                />
                <Route
                    path={routes.userManagement.createRole}
                    element={<CreateRolePage />}
                />
                <Route
                    path={routes.userManagement.editRole(":id")}
                    element={<EditRolePage />}
                />

                <Route
                    path={routes.accessDenied}
                    element={<AccessDeniedPage />}
                />
            </Route>
            {/* other pages */}
            {/* <Route></Route> */}
        </Routes>
    );
}

export default Routers;
